export default {
  content: 'pt-0'
}
